 const data = {
     links: [{
             "link": "https://stackoverflow.com/questions/51184136/display-an-image-from-url-in-reactjs",
             "domain": "https://stackoverflow.com",

             "title": "Display an image from url in ReactJS",
             "book": "Learn React JS",
             "date": "7 Octuber 2022",
             "image": "https://cdn.sstatic.net/Img/product/teams/screens/illo-home-search.png?v=1ccd850cd929",
             "important": false,
             "id": 13322,
             absolute_time: 7

         },
         {
             "link": "https://reactjs.org/",
             "domain": "https://reactjs.org",

             "title": "React A JavaScript library for building user interfaces",
             "book": "Learn React JS",
             "date": "7 Octuber 2022",
             "image": "https://assets.hongkiat.com/uploads/react-js-web-developers-toolkit/react-docs.jpg",
             "important": false,
             "id": 13322,
             absolute_time: 7

         },

         {
             "link": "https://www.javatpoint.com/reactjs-tutorial",
             "domain": "https://www.javatpoint.com",

             "title": "Learn ReactJS Tutorial",
             "book": "Learn React JS",
             "date": "7 Octuber 2022",
             "image": "https://stackify.com/wp-content/uploads/2018/08/word-image-104.png",
             "important": false,
             "id": 13322,
             absolute_time: 7

         },
         {
             "link": "https://www.w3schools.com/REACT/DEFAULT.ASP",
             "domain": "https://www.w3schools.com",

             "title": "React Tutorial",
             "book": "Learn React JS",
             "date": "7 Octuber 2022",
             "image": "https://i.pinimg.com/originals/1d/c3/d4/1dc3d43600d5787cce5718e13390d881.png",
             "important": false,
             "id": 13322,
             absolute_time: 7

         },
         {
             "link": "https://stackoverflow.com/questions/40834908/how-to-link-image-in-react-js-using-source",
             "domain": "https://stackoverflow.com",

             "title": "How to link image in react.js using source",
             "book": "Learn React JS",
             "date": "22 September 2022",
             "image": "https://cdn.sstatic.net/Img/product/teams/screens/illo-home-search.png?v=1ccd850cd929",
             "important": false,
             "id": 1376,
             absolute_time: 6

         },
         {
             "link": "https://stackoverflow.com/questions/208105/how-do-i-remove-a-property-from-a-javascript-object?rq=1",
             "domain": "https://stackoverflow.com",

             "title": "How do I remove a property from a JavaScript object?",
             "book": "JavaScript",
             "date": "12 November 2022",
             "image": "https://stackoverflow.co/img/company/press/stack-overflow.png",
             "important": true,
             "id": 1323,
             absolute_time: 8

         }, {
             "link": "https://www.w3schools.com/js/",
             "domain": "https://www.w3schools.com",

             "title": "JavaScript Tutorial",
             "book": "JavaScript",
             "date": "12 November 2022",
             "image": "https://i.pinimg.com/originals/1d/c3/d4/1dc3d43600d5787cce5718e13390d881.png",
             "important": true,
             "id": 1323,
             absolute_time: 8

         },
         {
             "link": "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
             "domain": "https://developer.mozilla.org",

             "title": "JavaScript Tutorial - Mozilla",
             "book": "JavaScript",
             "date": "12 November 2022",
             "image": "https://i.pinimg.com/originals/1d/c3/d4/1dc3d43600d5787cce5718e13390d881.png",
             "important": true,
             "id": 1323,
             absolute_time: 8

         },
         {
             "link": "https://stackoverflow.com/questions/195951/how-can-i-change-an-elements-class-with-javascript?rq=1",
             "domain": "https://stackoverflow.com",

             "title": "How can I change an element's class with JavaScript?",
             "book": "JavaScript",
             "date": "10 December 2022",
             "image": "https://miro.medium.com/max/1400/1*cbiq9DqLP_UEVqIOBb6MqQ.jpeg",
             "important": false,
             "id": 1343,
             absolute_time: 9

         },
         {
             "link": "https://stackoverflow.com/questions/2155737/remove-css-class-from-element-with-javascript-no-jquery?noredirect=1&lq=1",
             "domain": "https://stackoverflow.com",

             "title": "Remove CSS class from element with JavaScript (no jQuery)",
             "book": "JavaScript",
             "date": "15 July 2022",
             "image": "https://www.themely.com/wp-content/uploads/2018/12/wordpress-forums-stackoverflow-debug-errors-2.png",
             "important": true,
             "id": 1365,
             absolute_time: 5

         },
         {
             "link": "https://www.codechef.com/users/stray_fox_0156",
             "domain": "https://www.codechef.com",

             "title": "My codechef Profile",
             "book": "Personal Accounts",
             "date": "25 Febeuary 2022",
             "image": "https://media.geeksforgeeks.org/wp-content/uploads/20200328180309/ccvb.jpg",
             "important": true,
             "id": 1334,
             absolute_time: 1

         },
         {
             "link": "https://www.instagram.com/adi_sunny_neeraj_raviraj/",
             "domain": "https://www.instagram.com",

             "title": "My Instagram Profile",
             "book": "Personal Accounts",
             "date": "26 Febeuary 2022",
             "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuUv5Ju0I8RA6a2XPGlR0SrjB9xH3-HqB8ig&usqp=CAU",
             "important": false,
             "id": 136,
             absolute_time: 2

         },
         {
             "link": "https://www.linkedin.com/in/aditya-kumar-5abb4221b/",
             "domain": "https://www.linkedin.com",

             "title": "My LinkedIn Profile",
             "book": "Personal Accounts",
             "date": "27 Febeuary 2022",
             "image": "https://blog.hubspot.com/hs-fs/hubfs/kimberly%20hill.jpg?width=1698&name=kimberly%20hill.jpg",
             "important": true,
             "id": 137,
             absolute_time: 3

         },
         {
             "link": "https://www.hackerrank.com/aditya5kumar2012?hr_r=1",
             "domain": "https://www.hackerrank.com",

             "title": "My Hackrrank Profile",
             "book": "Personal Accounts",
             "date": "27 Febeuary 2022",
             "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTtaMBlRHwaTYzGiZYtQ8N8Brym-FeKeKmupK86GQdIkNpmu5DbqV8ElCBE8C12gQCQA48&usqp=CAU",
             "important": true,
             "id": 1307,
             absolute_time: 3

         },
         {
             "link": "https://www.codechef.com/START70C?order=desc&sortBy=successful_submissions",
             "domain": "https://www.codechef.com",

             "title": "Starters 70",
             "book": null,
             "date": "27 March 2022",
             "image": "https://media.geeksforgeeks.org/wp-content/uploads/20200328180309/ccvb.jpg",
             "important": false,
             "id": 134,
             absolute_time: 4

         },
         {
             "link": "https://www.codechef.com/problems/FREQARRRET",
             "domain": "https://www.codechef.com",

             "title": "Frequency Array Retrieval ",
             "book": null,
             "date": "27 March 2022",
             "image": "https://media.geeksforgeeks.org/wp-content/uploads/20200328180309/ccvb.jpg",
             "important": false,
             "id": 133,
             absolute_time: 4

         },




         {
             "link": "https://www.youtube.com/watch?v=yZqhBHPeuGc&list=RDyZqhBHPeuGc&start_radio=1",
             "domain": "https://www.youtube.com",

             "title": "Yusuf Eksioglu & Vehbi Inegol - Majnun Nabudum ",
             "book": "Yutube Remix",
             "date": "27 March 2021",
             "image": "https://www.01net.com/app/uploads/2021/05/MEA-YouTube.jpg",
             "important": false,
             "id": 132,
             absolute_time: 4

         }, {
             "link": "https://www.youtube.com/watch?v=LwuFpXG-2bg&list=RDyZqhBHPeuGc&index=3",
             "domain": "https://www.youtube.com",

             "title": "Yutube Remix - Nûsfur ( Sözer Sepetci & Amorf Remix )",
             "book": "Yutube Remix",
             "date": "27 March 2021",
             "image": "https://www.01net.com/app/uploads/2021/05/MEA-YouTube.jpg",
             "important": false,
             "id": 131,
             absolute_time: 4

         }, {
             "link": "https://www.youtube.com/watch?v=ou0phHbzz-0&list=RDyZqhBHPeuGc&index=8",
             "domain": "https://www.youtube.com",

             "title": "Dj Kantik - Teriyaki Boyz - Tokyo Drift & Sean Paul - Temperature (Remix)",
             "book": "Yutube Remix",
             "date": "27 March 2021",
             "image": "https://www.01net.com/app/uploads/2021/05/MEA-YouTube.jpg",
             "important": false,
             "id": 130,
             absolute_time: 4

         }
     ]

 }

 export default data;